<template>
  <b-breadcrumb class="app-breadcrumb breadcrumb-new" v-bind="{...$props, ...$attrs}" />
</template>

<script>
import CanLinkToLegacyPages from '@/mixins/CanLinkToLegacyPages'

export default {
  name: 'AppBreadcrumb',
  mixins: [CanLinkToLegacyPages]
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";
.breadcrumb-new {
  font-size: $font-s;
  background-color: inherit !important;
  margin-bottom: 0;
  padding: .5rem .75rem;
  .breadcrumb-item + .breadcrumb-item::before {
    content: "/" !important;
    color: $text-color-gray !important;
    padding: 0 0.25rem;
  }
}
.breadcrumb-item + .breadcrumb-item {
  padding: 0;
}
</style>
